<template>
    <div id="app" class="views">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>




// WEBPACK FOOTER //
// src/App.vue